<template>
  <v-card :width="width">
    <v-card-title class="third white--text font-weight-bold justify-center">
      <span class="ml-2">{{ title }}</span>
    </v-card-title>
    <v-card-text
      class="overflow-y-auto"
      style="height:400px;"
      @drop="drop($event)"
      @dragover.prevent
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="pb-4"
        color="third"
        @click.stop
      />
      <div class="full-height">
        <ul>
          <li
            v-for="(product, index) in filteredProductList"
            :key="index"
            :class="[{'lightBlue-bg':product.isSelected}, 'd-flex align-center justify-center table-line pointer']"
            style="border-bottom: 1px solid lightgrey"
            :draggable="filteredProductList.every(p => !p.isSelected)"
            @dragstart="dragStart($event, product)"
            @dragover.prevent
            @click="selectProduct(product)"
            @dblclick="updateProduct(product)"
          >
            <v-row no-gutters>
              <v-col class="flex-auto d-flex justify-start">
                <span :id="product.uuid" class="ml-4">{{ product.name }}</span>
              </v-col>
            </v-row>
          </li>
        </ul>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, watch, inject, computed, onBeforeMount } from '@vue/composition-api';
import { sendNotification } from '../../../helpers/utils';

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    products: {
      type: Array,
      default: () => []
    },
    customer: {
      type: Object,
      default: null
    },
    dropElement: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    selected: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const search = ref(null);

    const productsList = ref([]);

    const updateCustomerProduct = inject('updateCustomerProduct');
    const updateSelectedProducts = inject('updateSelectedProducts');

    const filteredProductList = computed(() => {
      if (search.value) {
        return productsList.value.filter(p => p.name.toLowerCase().includes(search.value.toLowerCase()));
      }

      return productsList.value;
    });

    const dragStart = (event, product) => {
      event.dataTransfer.setData('product_uuid', product.uuid);
      event.dataTransfer.setData('element_type', props.dropElement);
    };

    const drop = event => {
      const productUuid = event.dataTransfer.getData('product_uuid');
      const elementType = event.dataTransfer.getData('element_type');

      if (elementType === props.dropElement) {
        const text = 'Impossible de glisser-déposer sur la même colonne';
        sendNotification('error', text);
        return;
      }
      // element type is either 'allowedProducts' or 'limitedProducts'
      updateCustomerProduct(productUuid, elementType);
    };

    const selectProduct = product => {
      product.isSelected = !product.isSelected;

      if (product.isSelected) {
        const action = 'add';
        updateSelectedProducts(props.selected, product, action);
        return;
      }

      const action = 'splice';
      updateSelectedProducts(props.selected, product, action);
    };

    const updateProduct = product => {
      updateCustomerProduct(product.uuid, props.dropElement);
    };

    const updateProductList = () => {
      const products = [...props.products];

      productsList.value = products.map(p => ({
        ...p,
        isSelected: false
      }));
    };

    watch(() => props.products, () => {
      updateProductList();
    });

    onBeforeMount(() => {
      updateProductList();
    });

    return { search, productsList, dragStart, drop, selectProduct, updateProduct, filteredProductList };
  }

};
</script>

<style>
.table-line {
  height: 40px;
  font-size: 16px;
}

</style>
